export function wordCount(t) { return (t || '').trim().length; }

export function parsePollVotes(txt) {
  try {
    const v = JSON.parse(txt || '[]');
    return Array.isArray(v) ? v.filter((x) => x && x.id && (x.c === 'A' || x.c === 'B')) : [];
  } catch (e) { return []; }
}

export const MENTION_WORD = /^[\p{L}\p{N}_-]+/u;

export const MENTION_TAIL = /@([\p{L}\p{N}_-]{0,24})$/u;

// Splits chattekst in gewone stukjes en @vermeldingen (namen met spaties tellen mee).
export function mentionSplit(text, names, myNameLc) {
  const out = [];
  let buf = '';
  let i = 0;
  while (i < text.length) {
    if (text[i] === '@') {
      let hit = '';
      for (const n of names) {
        if (n && text.substr(i + 1, n.length).toLowerCase() === n.toLowerCase()) { hit = text.substr(i + 1, n.length); break; }
      }
      if (!hit) { const m = MENTION_WORD.exec(text.slice(i + 1)); if (m) hit = m[0]; }
      if (hit) {
        if (buf) { out.push({ t: buf, mention: false }); buf = ''; }
        out.push({ t: '@' + hit, mention: true, me: !!myNameLc && hit.toLowerCase() === myNameLc });
        i += 1 + hit.length;
        continue;
      }
    }
    buf += text[i];
    i++;
  }
  if (buf) out.push({ t: buf, mention: false });
  return out.length ? out : [{ t: text, mention: false }];
}

export function isSingleEmoji(text) {
  const t = (text || '').trim();
  if (!t) return false;
  return /^(\p{Extended_Pictographic}(\uFE0F|\u200D\p{Extended_Pictographic})*)$/u.test(t);
}

export function parseTs(iso) {
  const raw = (iso || '').replace(' ', 'T');
  if (!raw) return NaN;
  return Date.parse(/(Z|[+-]\d\d:?\d\d)$/.test(raw) ? raw : raw + 'Z');
}

export function withMedals(list, open) {
  const medals = ['🥇', '🥈', '🥉'];
  return list.map((r, i) => ({
    ...r, medal: medals[i] || '',
    title: 'Bekijk ' + r.name,
    onClick: () => open && open(r.id)
  }));
}

// Namen op alfabet, met Nederlandse sortering.
export const byName = (x, y) => (x.name || '').localeCompare(y.name || '', 'nl');

export function relTime(iso) {
  const t = parseTs(iso);
  if (isNaN(t)) return '';
  const m = Math.floor((Date.now() - t) / 60000);
  if (m < 1) return 'net nu';
  if (m < 60) return m + ' min geleden';
  const h = Math.floor(m / 60);
  if (h < 24) return h + ' uur geleden';
  const d = Math.floor(h / 24);
  return d === 1 ? 'gisteren' : d + ' dagen geleden';
}

// Tijdcode voor het moderatorlogboek: 29-07 14:03:12.
export function dayKey(d) {
  const x = d || new Date();
  const p = (n) => String(n).padStart(2, '0');
  return x.getFullYear() + '-' + p(x.getMonth() + 1) + '-' + p(x.getDate());
}

// De mod kiest de krabbel van de dag altijd een dag vooruit.
export function nextDayKey() { return dayKey(new Date(Date.now() + 86400000)); }

// Grove weergave van tijd op de site: "≈ 25 min", "≈ 1 u 20 min".
// Twee beelden zijn bijna altijd een heen-en-weer; die staat rustiger op 3 per
// seconde. Vanaf drie beelden loopt het op 8.
export function frameMs(n) { return n <= 2 ? 333 : 125; }

export function animDur(n) { return ((n * frameMs(n)) / 1000).toFixed(3); }

export function roughTime(sec) {
  if (!sec) return '0 min';
  const m = Math.max(1, Math.round(sec / 60));
  if (m < 60) return '≈ ' + (m < 10 ? m : Math.round(m / 5) * 5) + ' min';
  const h = Math.floor(m / 60), rest = Math.round((m % 60) / 5) * 5;
  return '≈ ' + h + ' u' + (rest ? ' ' + rest + ' min' : '');
}

export function stampTime(ms) {
  const d = new Date(ms);
  const p = (n) => String(n).padStart(2, '0');
  return p(d.getDate()) + '-' + p(d.getMonth() + 1) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
}
